import * as React from 'react';


/**
 * 异步请求组件
 */
export default function AsyncComponent(loadComponent, Loader = null) {
    return class AsyncComponent extends React.Component<{},{}> {
        static Component = null;
        state = { Component: AsyncComponent.Component };
        componentWillMount() {
            if (!this.state.Component) {
                loadComponent((Component) => {
                    AsyncComponent.Component = Component
                    this.setState({ Component });
                }, this.props, this.state);
            }
        }
        render() {
            const { Component } = this.state
            if (Component) {
                return <Component {...this.props} />
            }
            return Loader&&Loader();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/AsyncComponent/AsyncComponent.tsx